import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client"
import LocalStorageService from "../services/localstorage.service";
import { Author } from "../types/author"

const client = new HTTPClient()

export interface AuthorsResponse {
    authors?: {
        data: Array<Author>;
    };
    total?: number;
    error?: string;
}

export interface AuthorFilers {
    page?: number;
    limit?: number;
}

class Authors {
    static async getAll(filters: AuthorFilers) {
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/authors?page=${filters.page}&limit=${filters.limit}`,
            undefined,
            auth.accessToken
        )

        const response = await client.get(request)

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }

       return response.result as AuthorsResponse
    }

    static async find(authorId: number) {
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/authors/${authorId}`,
            undefined,
            auth.accessToken
          )
    
          const response = await client.get(request)
    
          if (!response.success) {
              return {
                error: response.errorMessage,
              }
          }
    
          return response.result as AuthorsResponse
    }

    static async save(author: Author){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            author.id ? RequestType.PUT : RequestType.POST,
            author.id ? `${AUTH_URL}/authors/${author.id}` : `${AUTH_URL}/authors`,
            JSON.stringify(author),
            auth.accessToken,
        );

        const response =  author.id ? await client.put(request) : await client.post(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as AuthorsResponse
    }

    static async delete(authorId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.DELETE,
            `${AUTH_URL}/authors/${authorId}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.delete(request)

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as AuthorsResponse
    }
}

export default Authors